import styled from '@emotion/styled'
import { Checkbox, Input } from '@vivaldis/antd-ui'
import { useTheme } from '@vivaldis/ui'
import { useTranslation } from 'react-i18next'
import { FontWeight } from '../../../styles/font'
import { BodyAlt } from '../../../Typography'
import { useWPSItemIndex } from '../../hooks/useWPSItemIndex'
import { useAiSuggestion } from '../../providers/AiSuggestionProvider'
import { useForm } from '../../providers/FormProvider'
import { WorkPostSheetItemTypesEnum } from '../../types'
import { AiSuggestedTag } from '../AiSuggestedTag'

interface Props {
  name: WorkPostSheetItemTypesEnum
  // show a comment input below the checkbox when it's checked
  withComment?: boolean
}

export const WPSItemCheckbox = ({ name, withComment = true }: Props) => {
  const [t, i18n] = useTranslation('web_ui')
  const theme = useTheme()

  const { values } = useForm()
  const { isItemAiSuggested } = useAiSuggestion()
  const getItemIndex = useWPSItemIndex()

  const index = getItemIndex(name)
  const translationKey = `work_post_sheet_form.${name.toLocaleLowerCase()}`
  const hasCode = i18n.exists(`${translationKey}.code`, { ns: 'web_ui' })

  return (
    <div>
      <Row>
        <Checkbox name={`items[${index}].checked`} style={{ marginBottom: 8 }}>
          {t(`${translationKey}.label`)}
          {hasCode ? (
            <BodyAlt
              marginLeft={8}
              color={theme.gray7}
              letterSpacing={0}
              fontWeight={FontWeight.italic}
            >
              — {t(`${translationKey}.code`)}
            </BodyAlt>
          ) : null}
        </Checkbox>
        {isItemAiSuggested(name) ? <AiSuggestedTag /> : null}
      </Row>
      {withComment && values.items[index]?.checked ? (
        <Input name={`items[${index}].comment`} style={{ marginBottom: 8 }} />
      ) : null}
    </div>
  )
}

const Row = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`
